<template>
  <div class="popup-createRoom">
    <div class="popup-createRoom-container">
      <div v-if="mainStep !== 'add-table'" class="nav-toggle" @click="closePopup">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
      <el-popover placement="right" width="200" v-model="quitAddTable" popper-class="popup-delete black-inputs">
        <p>Êtes vous sûr de vouloir quitter sans valider cette table ?</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" class="dark" type="primary" @click="quitAddTable = false">Annuler</el-button>
          <el-button type="primary" size="mini" @click="cancelAddTable">Confirmer</el-button>
        </div>
        <div v-if="mainStep === 'add-table'" slot="reference" class="nav-toggle" @click="closePopup">
          <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
        </div>
      </el-popover>
      <div class="popup-createRoom-rooms black-inputs" v-if="mainStep === 'create-rooms'">
        <div v-if="getRoomsDatas !== null">
          <div class="popup-createRoom-title">Editer une salle :</div>
          <draggable @end="sortTab">
            <div class="popup-createRoom-btn" v-for="r in orderedRoom" :key="r.name" :id="r.id">
              <el-button class="dark w80" @click="editRoom(r.id)">{{ r.name }}</el-button>
              <el-popover placement="right" width="200" v-model="popupDeleteRoom[r.id]"
                popper-class="popup-delete black-inputs">
                <p>Si vous voulez supprimer cette salle, merci d'indiquer votre mot de passe</p>
                <el-input v-model="checkPassValue" type="password"></el-input>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" class="dark" type="primary"
                    @click="popupDeleteRoom[r.id] = false">Annuler</el-button>
                  <el-button type="primary" size="mini" @click="checkBeforeDelete(r)">Confirmer</el-button>
                </div>
                <el-button class="dark" slot="reference" type="info" icon="el-icon-close" circle></el-button>
              </el-popover>
            </div>
          </draggable>
        </div>
        <div class="popup-createRoom-title">Ajouter une salle :</div>
        <el-button class="dark" @click="subStep = 'create-room'" v-if="subStep !== 'create-room'">Ajouter une
          salle</el-button>
        <transition name="fade">
          <div v-if="subStep === 'create-room'">
            <el-form class="createRoom-form" ref="formNewRoom" :model="formNewRoom" label-width="0">
              <el-form-item>
                <el-input class="dark" v-model="formNewRoom.name" placeholder="Nom de la salle"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmitNewRoom">Valider</el-button>
              </el-form-item>
              <el-form-item>
                <el-button class="dark" type="primary" @click="cleanFormRoom">Annuler</el-button>
              </el-form-item>
            </el-form>
          </div>
        </transition>
        <div class="link" @click='showHideLockedRoom'>Définir des plages d’ouverture / fermeture</div>
      </div>
      <div class="popup-createRoom-room black-inputs" v-if="mainStep === 'edit-room'">
        <div class="popup-createRoom-title"
          v-if="getSelectedRoom !== '' && getRoomsDatas !== null && getRoomsDatas[getSelectedRoom] !== undefined">
          <div v-if="!editRoomName">
            <span class="popup-createRoom-title_text">{{ getRoomsDatas[getSelectedRoom].name }}</span>
            <el-button class="dark" icon="el-icon-edit" @click="editRoomNameOn" circle></el-button>
          </div>
          <div v-if="editRoomName">
            <span class="popup-createRoom-title_text">
              <el-input ref="editRoomNameInput" :placeholder="getRoomsDatas[getSelectedRoom].name"
                v-model="newRoomName"></el-input>
            </span>
            <el-button class="green" icon="el-icon-check" @click="editRoomNameValidate" circle></el-button>
          </div>
        </div>
        <div class="popup-createRoom-desc">Réalisez votre plan de table en déplaçant les tables créées à votre guise
        </div>
        <div class="popup-createRoom-desc">Cliquez sur une table pour la sélectionner</div>
        <el-button class="dark" @click="startNewTable">Ajouter une table</el-button>
      </div>
      <div v-if="editTable">
        <el-form class="createRoom-form black-inputs black-inputs_2" ref="formTable.data" :model="formTable.data"
          label-width="35%">
          <div class="black-inputs_2-container">
            <el-form-item label="Forme">
              <el-radio-group @change="updateTableForme({ data: formTable.data.style, id: formTable.data.id })"
                v-model="formTable.data.style">
                <el-radio-button class="rect" label="rect"></el-radio-button>
                <el-radio-button class="circle" label="circle"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Longueur" v-if="formTable.data.style === 'rect'">
              <el-input-number class="text-centered"
                @change="updateTableWidth({ data: formTable.data.width, id: formTable.data.id })" :min="1"
                v-model="formTable.data.width"></el-input-number>
            </el-form-item>
            <el-form-item label="Largeur" v-if="formTable.data.style === 'rect'">
              <el-input-number class="text-centered"
                @change="updateTableHeight({ data: formTable.data.height, id: formTable.data.id })" :min="1"
                v-model="formTable.data.height"></el-input-number>
            </el-form-item>
            <el-form-item label="Diamètre" v-if="formTable.data.style === 'circle'">
              <el-input-number class="text-centered"
                @change="updateTableDiameter({ data: formTable.data.width, id: formTable.data.id })" :min="1"
                v-model="formTable.data.width"></el-input-number>
            </el-form-item>
            <el-form-item label="Nb de places">
              <el-input-number class="text-centered"
                @change="updateTableNbCouvert({ data: formTable.data.nbCouvert, id: formTable.data.id })" :min="1"
                v-model="formTable.data.nbCouvert"></el-input-number>
            </el-form-item>
            <el-form-item label="Angle">
              <el-input-number class="text-centered" :min="0" :max="180" :step="45"
                @change="chooseAngle(formTable.data.angle, formTable.data.id)"
                v-model="formTable.data.angle"></el-input-number>
            </el-form-item>
            <el-form-item label="Numéro">
              <el-input-number class="text-centered" @change="updateTableId" @keyup.native="updateTableId" :min="1"
                v-model="formTable.data.id"></el-input-number>
            </el-form-item>
          </div>
          <el-form-item v-if="mainStep === 'add-table'">
            <el-button type="primary" @click="validNewTable">Valider</el-button>
          </el-form-item>
          <el-form-item v-if="mainStep === 'add-table'">
            <el-button class="dark" type="primary" @click="cancelAddTable">Annuler</el-button>
          </el-form-item>
          <el-form-item v-if="mainStep !== 'add-table'">
            <el-button class="dark" type="primary" @click="duplicateTable">Dupliquer</el-button>
          </el-form-item>
          <el-form-item v-if="mainStep !== 'add-table'">
            <el-popover placement="right" width="200" v-model="popupDeleteTable"
              popper-class="popup-delete black-inputs">
              <p>Voulez-vous supprimer cette table ?</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" class="dark" type="primary" @click="popupDeleteTable = false">Annuler</el-button>
                <el-button type="primary" size="mini" @click="removeSelectedTable">Confirmer</el-button>
              </div>
              <el-button slot="reference" class="dark" type="primary">Supprimer</el-button>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Notification } from 'element-ui'
import _ from 'lodash'
import draggable from 'vuedraggable'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { fixHover } from '../../tools/eventTools'

export default {
  name: 'PopupCreateRoom',
  components: { draggable },
  data() {
    return {
      mainStep: 'create-rooms',
      subStep: '',
      lastIdSaved: -1,
      popupDeleteTable: false,
      quitAddTable: false,
      popupDeleteRoom: {},
      checkPassValue: '',
      updatingIdTable: false,
      intervalUpdateTable: null,
      countIdTableChange: 0,
      editRoomName: false,
      newRoomName: '',
      formTable: {
        data: {
          style: 'rect',
          width: 1,
          height: 1,
          nbCouvert: 2,
          angle: 0,
          id: 1
        }
      },
      formNewRoom: {
        name: ''
      }
    }
  },
  watch: {
    'getSelectedTables': function (val, oldVal) {
      if (val.length > 0 && this.mainStep !== 'add-table') {
        this.mainStep = 'edit-table'
        this.updateFormTable(val)
      } else if (val.length === 0 && this.getModEdition) this.mainStep = 'edit-room'
    },
    'getSelectedRoom': function (val, oldVal) {
      if (val === '') {
        switch (this.mainStep) {
          case 'edit-room':
          case 'edit-table':
            this.mainStep = 'create-rooms'
            break
          case 'add-table':
            this.cancelAddTable()
            this.mainStep = 'create-rooms'
            break
        }
      }
    }
  },
  destroyed: function () {
    if (this.mainStep === 'add-table') this.cancelAddTable()
    this.closeEdition()
    this.loadRoomsStore()
  },
  computed: {
    ...mapGetters({
      getRoomsDatas: 'newRooms/getRoomsDatas',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getDisplayTableById: 'newRooms/getDisplayTableById',
      getModEdition: 'newRooms/getModEdition',
      getNewTableData: 'newRooms/getNewTableData',
      getSelectedTables: 'newRooms/getSelectedTables',
      getDisplayTableIds: 'newRooms/getDisplayTableIds'
    }),
    fixH: function () {
      return fixHover
    },
    orderedRoom: function () {
      return _.orderBy(this.getRoomsDatas, 'order')
    },
    getFormTableId: function () {
      return this.formTable.data.id
    },
    editTable: function () {
      if (this.mainStep === 'add-table') {
        return true
      } else if (this.mainStep === 'edit-table') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions({
      createNewRoom: 'newRooms/createNewRoom',
      createTable: 'newRooms/createTable',
      createNewTableData: 'newRooms/createNewTableData',
      loadCurrentSelectRoom: 'newRooms/loadCurrentSelectRoom',
      updateTableWidth: 'newRooms/updateTableWidth',
      updateTableHeight: 'newRooms/updateTableHeight',
      updateTableDiameter: 'newRooms/updateTableDiameter',
      updateTableAngle: 'newRooms/updateTableAngle',
      updateTableNbCouvert: 'newRooms/updateTableNbCouvert',
      updateTableForme: 'newRooms/updateTableForme',
      setTableId: 'newRooms/setTableId',
      removeTable: 'newRooms/removeTable',
      closeEdition: 'newRooms/closeEdition',
      unSelectedTables: 'newRooms/unSelectedTables',
      showHidePopupCreateRoom: 'displayer/showHidePopupCreateRoom',
      checkPassword: 'newUsers/checkPassword',
      removeRoom: 'newRooms/removeRoom',
      updateRoomOrder: 'newRooms/updateRoomOrder',
      updateRoomName: 'newRooms/updateRoomName',
      saveRoom: 'newRooms/saveRoom',
      loadRoomsStore: 'newRooms/loadRoomsStore',
      showHideLockedRoom: 'displayer/showHideLockedRoom'
    }),
    ...mapMutations({
      setSelectedTable: 'newRooms/setSelectedTable',
      setModAddTable: 'newRooms/setModAddTable',
      setModEdition: 'newRooms/setModEdition',
      setSelectedRoom: 'newRooms/setSelectedRoom'
    }),
    sortTab: function (evt) {
      Object.entries(evt.to.children).forEach(([order, room]) => {
        this.updateRoomOrder({ id: room.id, order: order })
      })
    },
    editRoomNameOn: function () {
      this.editRoomName = true
      setTimeout(() => this.$refs.editRoomNameInput.focus(), 50)
    },
    editRoomNameValidate: function () {
      if (this.newRoomName !== '') {
        this.updateRoomName(this.newRoomName).then(() => {
          this.editRoomName = false
        })
      }
      this.editRoomName = false
    },
    checkBeforeDelete: function (room) {
      this.checkPassword(this.checkPassValue).then(() => {
        this.checkPassValue = ''
        this.popupDeleteRoom[room.id] = false
        this.removeRoom(room)
      })
    },
    cleanFormRoom: function () {
      this.formNewRoom.name = ''
      this.subStep = ''
    },
    onSubmitNewRoom: function () {
      let tmpId = this.formNewRoom.name.split(' ').join('-').toLowerCase()
      this.createNewRoom({ name: this.formNewRoom.name, id: tmpId }).then((data) => {
        Notification.success({
          title: 'Nouvelle salle créée',
          message: data.name,
          position: 'bottom-right'
        })
        this.formNewRoom.name = ''
      })
      this.subStep = ''
    },
    editRoom: function (selectedId) {
      this.mainStep = 'edit-room'
      this.setModEdition(true)
      this.loadCurrentSelectRoom(selectedId)
    },
    updateTableId: function (e) {
      let val = e
      if (e.type === 'keyup') val = e.srcElement.value
      let lastId = this.getSelectedTables[0]

      if (val !== lastId && val !== '') {
        // hack -> use interval for prevent promize setTableId and don't duplicate table création
        if (this.intervalUpdateTable !== null) clearInterval(this.intervalUpdateTable)
        this.intervalUpdateTable = window.setInterval(() => {
          let checkedid = this.authorizedValue(val, (val > lastId))

          if (checkedid !== this.formTable.data.id) {
            this.formTable.data.id = checkedid
          }
          clearInterval(this.intervalUpdateTable)
          this.setTableId({ newid: checkedid, lastid: lastId }).then(() => {
            this.unSelectedTables()
            this.setSelectedTable(checkedid)
          })
        }, 700)
      }
    },
    cancelAddTable: function () {
      this.setModAddTable(false)
      this.removeTable(this.formTable.data.id)
      this.unSelectedTables()
      this.quitAddTable = false
      this.mainStep = 'edit-room'
    },
    startNewTable: function (data = null) {
      this.mainStep = 'add-table'
      this.setModAddTable(true)
      if (data.style === undefined || data === null) {
        this.formTable = {
          data: {
            style: 'rect',
            width: 1,
            height: 1,
            nbCouvert: 2,
            angle: 0,
            id: 1,
            idT: 1
          }
        }
      } else {
        this.formTable = {
          data: data
        }
      }
      if (this.getDisplayTableIds.length !== 0) this.formTable.data.id = this.getDisplayTableIds[this.getDisplayTableIds.length - 1] + 1
      this.setSelectedTable(this.formTable.data.id)
      this.createTable({ room: this.getSelectedRoom, table: this.getNewTableData(this.formTable.data) })
    },
    validNewTable: function () {
      this.setModAddTable(false)
      this.unSelectedTables()
      this.saveRoom()
      this.mainStep = 'edit-room'
    },
    duplicateTable: function () {
      let datas = Object.assign({}, this.formTable.data)
      this.startNewTable(datas)
    },
    updateFormTable: function (tid) {
      let t = this.getDisplayTableById(tid)
      if (t !== undefined) {
        this.formTable.data.id = t.id
        this.formTable.data.style = t.forme
        this.formTable.data.width = t.width
        this.formTable.data.height = t.height
        this.formTable.data.nbCouvert = t.nbCouvert
        this.formTable.data.angle = t.angle
      }
    },
    authorizedValue: function (idChecked, positif) {
      let tids = this.getDisplayTableIds
      let foundIndex = tids.findIndex(function (tid) {
        return tid === idChecked
      })
      let newId = 0
      if (foundIndex !== -1) {
        let step = 1
        let end = tids.length - 1
        if (!positif) {
          step = -1
          end = 1
          for (let i = foundIndex; i > end; i += step) {
            if (tids[i - 1] + 1 < tids[i]) {
              newId = tids[i] - 1
              break
            }
          }
        } else {
          for (let i = foundIndex; i < end; i += step) {
            if (tids[i + 1] - 1 > tids[i]) {
              newId = tids[i] + 1
              break
            }
          }
        }
        if (newId === 0) {
          if (positif) newId = tids[tids.length - 1] + 1
          else newId = tids[0] - 1
        }
      } else {
        newId = idChecked
      }
      if (newId === 0) return tids[tids.length - 1] + 1
      return newId
    },
    closePopup: function () {
      switch (this.mainStep) {
        case 'add-table':
          this.quitAddTable = true
          break
        case 'edit-room':
          this.mainStep = 'create-rooms'
          this.setSelectedRoom('')
          break
        case 'edit-table':
          this.unSelectedTables()
          this.saveRoom()
          this.mainStep = 'edit-room'
          break
        case 'create-rooms':
          this.showHidePopupCreateRoom()
          break
      }
    },
    removeSelectedTable: function () {
      this.removeTable(this.getSelectedTables[0])
      this.unSelectedTables()
      this.saveRoom()
      this.setModAddTable(false)
    },
    chooseAngle: function (angle, id) {
      if (angle === 180) this.formTable.data.angle = 0
      this.updateTableAngle({ data: angle, id: id })
    }
  },
  created: function () {
    this.setModEdition(true)
    this.setSelectedRoom('')
  }
}
</script>

<style lang="scss">
@use "../../styles/vars";

.link {
  text-align: center;
  text-decoration: underline;
  color: var(--color_blue_azure);
  margin: auto;
  margin-top: 20px;
  cursor: pointer;
  width: 70%;
}

.createRoom {
  &-form {
    padding: 10px 20px;
  }
}
</style>
